export default __webpack_public_path__ + "static/media/save__popup.a66320c2.svg";